import { FormValuesKey } from '~/work_order/modify_work_order/PageDataProvider'

export const FEE_PROFILE_CHANGE_EFFECTIVE_DATE = 'fee_profile_change_effective_date'
export const BILL_RATE = 'bill_rate'
export const BUDGET = 'budget'
export const CALCULATION_PACK = 'calculation_pack'
export const CALENDAR_PAY_PROFILE = 'calendar_pay_profile'
export const DIRECT_HIRE_SALARY = 'direct_hire_salary'
export const END_DATE = 'end_date'
export const END_TIME = 'end_time'
export const END_TIMEZONE = 'end_timezone'

export const EXEMPT_STATUS = 'exempt_status'
export const FEE_PROFILE = 'fee_structure_profile'
export const WORK_WEEK = 'work_week'
export const SOURCE = 'source'
export const MIN_HOURS = 'min_hours'
export const MODIFICATION_REASON = 'modification_reason'
export const NOT_QUALIFIED_RATE = 'not_qualified_rate'
export const OTHER_REASON = 'other_reason'

export const OVERTIME_PROFILE = 'overtime_profile'
export const PREMIUM_RATE = 'premium_rate'
export const DISABLE_BACKDATING = 'disable_backdating'
export const PAYMENTS = 'payments'
export const PAY_RATE = 'pay_rate'

export const ORIENTATION_HOURS = 'orientation_hours'
export const LOW_CENSUS_LIMIT_HOURS = 'low_census_limit_in_hours'
export const PAY_PARITY_RATE = 'pay_parity_rate'
export const MARKUP = 'markup'
export const OVERTIME_MARKUP = 'overtime_markup'
export const DOUBLE_TIME_MARKUP = 'double_time_markup'

export const RATES = 'rates'

export const FEE_PROFILES = 'fee_profiles'

export const RATE_CHANGE_EFFECTIVE_DATE = 'rate_change_effective_date'
export const SHIFT_CHANGE_EFFECTIVE_DATE = 'shift_change_effective_date'
export const SHIFT_STRATEGY = 'shift_strategy'
export const SHIFTS = 'shifts'

// This is the new UI field that compounds shift + differential + strategy
export const SHIFTS_ARRAY = 'shifts_array'

export const SHIFT_DIFFERENTIAL_MAPPING = 'shift_differential_mapping'
export const START_DATE = 'start_date'
export const WORK_TYPE_CHANGE_EFFECTIVE_DATE = 'work_type_change_effective_date'

// plural for array edit
export const WORK_TYPE_PROFILES = 'work_type_profiles'

export const WORK_TYPE_PROFILE = 'work_type_profile'
export const WORK_TYPE_OVERRIDES = 'work_type_overrides'
export const EVENT_BASED_EXPENSES = 'event_based_expenses'
export const DEFAULT_EVENT_BASED_EXPENSE_CC = 'default_event_based_expense_cc'

export const WORK_TYPE_OVERRIDES_OPTIONS = 'work_type_overrides_options'

export const WORK_HOURS_PER_DAY = 'work_hours_per_day'

export const SECTION_FLAG_CUSTOM_FIELDS = '_custom_fields_edited'
export const GENERIC_FIELDS = 'generic_fields'

export const CANDIDATE_GENERIC_FIELDS = 'candidate_generic_fields'

export const SECTION_FLAG_ORG_UNIT = '_org_unit_edited'
export const SECTION_FLAG_LOCATION = '_location_edited'
export const SECTION_FLAG_TAX_OVERRIDES = '_tax_overrides_edited'
export const SECTION_FLAG_SCHEDULED_BILLING = '_scheduled_billing_edited'

export const SECTION_FLAG_GENERAL = '_general_edited'

export const SECTION_FLAG_APPROVERS_MANAGERS = '_approvers_managers_edited'

export const CHARGE_CODES = 'charge_codes'
export const BUDGET_ALLOCATIONS = 'budget_allocations'

// Used for ephemeral storage of charge codes in form
export const CHARGE_CODES_FORM_DATA = 'chargeCodesFormData'
export const SECTION_FLAG_CHARGE_CODES = '_charge_codes_edited'
export const SECTION_FLAG_DURATION = '_duration_edited'
export const BUSINESS_UNIT = 'business_unit'
export const PROGRAM_TEAM_ENTITY = 'program_team_entity'
export const VENDOR = 'vendor'
export const CANDIDATE = 'candidate'
export const LOCATION = 'location'
export const LOCATIONS = 'locations'
export const BILLING_SCHEDULE = 'billing_schedule'
export const TAX_OVERRIDE = 'tax_override'
export const RESOURCE_MANAGER = 'resource_manager'
export const PROGRAM_TEAM = 'program_team'
export const ADDITIONAL_MANAGERS = 'additional_managers'
export const TIMESHEET_APPROVERS = 'timesheet_approvers'
export const EXPENSE_APPROVERS = 'expense_approvers'
export const TIMEKEEPER = 'timekeeper'
export const TITLE = 'title'
export const REASON_FOR_HIRE = 'reason_for_hire'
export const EXPENSE_TYPE = 'expense_type'

export const EXTERNAL_ID = 'external_id'
export const REASON_FOR_HIRE_TEXT = 'reason_for_hire_text'
export const PERSON_BEING_BACK_FILLED = 'person_being_back_filled'
export const PROVISIONING_ELIGIBLE = 'provisioning_eligible'
export const JOB_TEMPLATE = 'job_template'
export const JOB_TEMPLATE_JOB_TYPE = 'job_template_job_type'
export const JOB_SITE = 'job_site'
export const WORKER_CLASSIFICATION = 'worker_classification'

export const PROVISIONING_TYPES = 'provisioning_types'
export const BILLING_CYCLE_DEF = 'billing_cycle_def'
export const ConnectorFields = {
  WorkdayFields: {
    POSITION_TYPE: 'connector_data.workday.position_type',
    POSITION: 'connector_data.workday.position',
    CLOSE_OLD_POSITION: 'connector_data.workday.close_old_position'
  }
}

export const RATE_SECTION_RETAINED_FUTURE_DATES = 'rate_section_retained_future_dates'

// Rate Fields that actually can be effective dated
export const RATE_SECTION_FIELDS: FormValuesKey[] = [
  PAY_RATE,
  BILL_RATE,
  MARKUP,
  OVERTIME_MARKUP,
  DOUBLE_TIME_MARKUP,
  MIN_HOURS,
  NOT_QUALIFIED_RATE,
  CALCULATION_PACK,
  PAY_PARITY_RATE,
  WORK_HOURS_PER_DAY
]

// Rate fields that are on EDF but are not actually effective dated yet
export const RATE_SECTION_SINGLE_VALUE_FIELDS: FormValuesKey[] = [
  CALENDAR_PAY_PROFILE,
  EXEMPT_STATUS,
  OVERTIME_PROFILE,
  PREMIUM_RATE,
  PAY_PARITY_RATE
]

export const RATE_SECTION_FIELDS_DISPLAY: FormValuesKey[] = [
  'pay_rate',
  'bill_rate',
  'markup',
  'overtime_markup',
  'double_time_markup',
  'vendor_rate',
  'client_rate',
  'fee_structure_profile',
  'calculation_pack',
  'min_hours',
  'not_qualified_rate',
  'shifts',
  'shift_strategy',
  'shift_differential_mapping',
  'work_hours_per_day'
]

export const SHIFT_SECTION_FIELDS: FormValuesKey[] = [SHIFT_STRATEGY, SHIFTS, SHIFT_DIFFERENTIAL_MAPPING]

export const FEE_PROFILE_SECTION_FIELDS: FormValuesKey[] = [FEE_PROFILE]

export const LOCATION_SECTION_FIELDS: FormValuesKey[] = [LOCATION]
export const SCHEDULED_BILLING_SECTION_FIELDS: FormValuesKey[] = [BILLING_SCHEDULE]
export const TAX_OVERRIDE_SECTION_FIELDS: FormValuesKey[] = [TAX_OVERRIDE]
export const TAX_OVERRIDE_RETAINED_FUTURE_DATES = 'tax_override_retained_future_dates'

export const WORK_TYPE_SECTION_FIELDS: FormValuesKey[] = [WORK_TYPE_PROFILE, WORK_TYPE_OVERRIDES]

export enum WorkTypeOverridesOptions {
  USE_DEFAULT_VALUES = 1,
  OVERRIDE_WITH_CUSTOM_VALUES = 2
}

export const DIRECT_HIRE_SECTION_FIELDS: FormValuesKey[] = [DIRECT_HIRE_SALARY]
export const GENERIC_FIELDS_SECTION_FIELDS: FormValuesKey[] = [GENERIC_FIELDS]
export const CHARGE_CODE_SECTION_FIELDS: FormValuesKey[] = [CHARGE_CODES, BUDGET_ALLOCATIONS]
export const ORG_UNIT_SECTION_FIELDS: FormValuesKey[] = [BUSINESS_UNIT, RESOURCE_MANAGER]
export const EVENT_BASED_EXPENSES_SECTION_FIELDS: FormValuesKey[] = [
  EVENT_BASED_EXPENSES,
  DEFAULT_EVENT_BASED_EXPENSE_CC
]

export const GENERAL_SECTION_FIELDS: FormValuesKey[] = [
  TITLE,
  REASON_FOR_HIRE,
  REASON_FOR_HIRE_TEXT,
  PERSON_BEING_BACK_FILLED,
  WORK_WEEK,
  PROVISIONING_ELIGIBLE,
  PROVISIONING_TYPES,
  SOURCE,
  JOB_TEMPLATE_JOB_TYPE,
  JOB_SITE,
  BILLING_CYCLE_DEF,
  WORKER_CLASSIFICATION,
  EXPENSE_TYPE,
  EXTERNAL_ID,
  ORIENTATION_HOURS,
  LOW_CENSUS_LIMIT_HOURS
]

export const APPROVERS_AND_MANAGERS_SECTION_FIELDS: FormValuesKey[] = [
  ADDITIONAL_MANAGERS,
  PROGRAM_TEAM,
  TIMESHEET_APPROVERS,
  EXPENSE_APPROVERS,
  TIMEKEEPER
]
